import React, { createContext } from 'react';
import { Button, Modal } from 'alurkerja-ui';
import { FaPlus } from 'react-icons/fa';
import { RenderScreen } from './Screen/ScreenLoader';

type ModalStartProcessProps = {
  label: string;
  processDefinitionKey: string;
  taskDefinitionKey: string;
  refetch: () => void; // Add refetch prop
};

type IModalContext = {
  open: boolean;
  closeModal: () => void;
};

export const ModalContext = createContext<IModalContext>({} as IModalContext);
const ModalStartProcess: React.FC<ModalStartProcessProps> = ({ label, taskDefinitionKey, processDefinitionKey, refetch }) => {
  return (
    <Modal
      title={label}
      maxWidth="2xl"
      triggerButton={
        <Button className="p-2 px-3 items-center text-sm text-white flex flex-row gap-2" color="green">
          <FaPlus size={16} />
          <div> Start Process</div>
        </Button>
      }
    >
      {({ closeModal }) => (
        <div>
          <ModalContext.Provider value={{ open: true, closeModal: () => { refetch(); closeModal(); } }}>
            <RenderScreen
              taskDefinitionKey={taskDefinitionKey}
              processDefinitionKey={processDefinitionKey}
            ></RenderScreen>
          </ModalContext.Provider>
        </div>
      )}
    </Modal>
  );
};

export default ModalStartProcess;
